<template>
	<vs-popup
		:title="$t('payRewardToAuthor')"
		class="set-ticket-done"
		:active.sync="activeProp"
	>
		{{ $t('allowAuthorPaymentReward') }}
		<div class="set-ticket-done__controls">
			<vs-button
				@click="confirm"
				color="success"
			>{{ $t('pay') }}</vs-button>

			<vs-button
				@click="close"
				color="#9a9a9a"
				type="flat"
			>{{ $t('doCancel') }}</vs-button>
		</div>
	</vs-popup>
</template>

<script>
export default {
	name: "SetStageDoneAfterPatchModePopup",
	props: {
		active:				{ default: false, type: Boolean },
	},
	// data() {
	// 	return {

	// 	}
	// },
	computed: {
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			}
		}
	},
	methods: {
		confirm() {
			this.$emit("confirm");
			this.activeProp = false;
		},
		close() {
			this.activeProp = false;
		}
	}
}
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.set-ticket-done {
	&__controls {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.vs-popup {
		max-width: 450px !important;
		width: 100% !important;
		padding: 0;

		&--content {
			width: 100%;
			height: 100%;
		}

		&--close,
		&--title h3 {
			color: $success;
		}

		&--button {
			display: flex;
			justify-content: flex-end;
			padding-top: 15px;
		}
	}

	.vs-input {
		width: 100%;
	}

	.vs-input--label {
		transition: color 0.3s ease;
	}

	.vs-input-primary.isFocus .vs-input--label {
		color: $success;
	}

	.vs-input-primary .vs-input--input:focus {
		border-color: $success !important;
	}
}
</style>
